import { render, staticRenderFns } from "./first-screen.vue?vue&type=template&id=f89ce756&"
import script from "./first-screen.vue?vue&type=script&lang=js&"
export * from "./first-screen.vue?vue&type=script&lang=js&"
import style0 from "./first-screen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports